import React, { useContext } from 'react';
import InputConfig from '../../../../Components/InputConfig';
import SwitchInput from '../../../../Components/SwitchInput';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import PageHeading from '../../../../Components/PageHeading';
//mui imports====
import { Grid } from '@mui/material';
import useCommonStyles from '../../../../commonStyles';
import Paper from '@mui/material/Paper';

//===============

const DemandEngineConfig = ({ keyData , featureDescription}) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Vast FE Config"
				headingPath={['Dashboard', 'Framerate', 'Network Data', 'Vast FE Config']}
				description="Manage Demand Engine Configuration ( NOTE : Dc [Daisy Chaining] inventory usage would be via tp vast config )"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={1} style={{ marginLeft: '4rem', marginTop: '3rem', width: '90%' }}>
				<Grid item xs={2.4} style={{ marginTop: '3rem', marginBottom: '2rem' }}>
					<SwitchInput
						keyData={keyData + '.enabled'}
						label="Enabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
						containerStyles={{ marginTop: '2rem', width: 'fit-content' }}
					/>
				</Grid>
				<Grid item xs={2.4} style={{ marginTop: '3rem', marginBottom: '2rem' }}>
					<SwitchInput
						keyData={keyData + '.startWithDcVasts'}
						label="Start With Dc"
						disabled={!rawConfig[keyData + '.enabled']}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
						containerStyles={{ marginTop: '2rem', width: 'fit-content' }}
					/>
				</Grid>
				<Grid item xs={2.4}>
					<InputConfig
						label="Dc Vast Limit"
						keyData={keyData + '.dcVastLimit'}
						editable={!!rawConfig[keyData + '.enabled']}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={2.4}>
					<InputConfig
						label="Default Vast Limit"
						keyData={keyData + '.defaultVastLimit'}
						editable={!!rawConfig[keyData + '.enabled']}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<Grid item xs={2.4}>
					<InputConfig
						label="Initial Requests"
						keyData={keyData + '.initialRequestsLimit'}
						editable={!!rawConfig[keyData + '.enabled']}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default DemandEngineConfig;
